import { detailedOrganizationFragment } from './fragmentsOrganization';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type OrganizationDetailRecord = QueryAtomResult<
  typeof organizationDetailQueryAtom
>[number];

export const organizationDetailQueryAtom = createQueryAtomFactory(
  'admin.organizationDetail',
  (params: { organizationId: string }) => ({
    organizations: {
      __args: {
        filter: { ids: [params.organizationId] },
        pagination: { limit: 1, offset: 0 },
      },
      entries: detailedOrganizationFragment,
    },
  }),
  {
    select: ({ organizations }) => organizations.entries,
  },
);
